var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OurPage',{attrs:{"data-cy":"users-page","title":_vm.$t('title.focusGroup._'),"gray":""}},[_c('FocusGroupList',{attrs:{"items":_vm.featuresList},on:{"onClickRow":_vm.onClickRow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }